import React, {Component} from 'react';
import {Paper, Typography, Grid} from 'material-ui';
import { Helmet } from "react-helmet";
import HeaderBar from './components/HeaderBar';

class Homepage extends Component {
  renderGettingStarted = () => {
    return (
      <div style={{padding: '1rem'}}>
        <Paper>
          <div style={{padding: '2rem'}}>
            <Typography type="headline">Overview</Typography>
            <Typography type="body2">
              Ayo main Adu Jempol! Permainan yang sangat sederhana namun sangat
              menyenangkan! Sebelum mulai, setiap pemain harap add akun adu
              jempol dulu ya.
            </Typography>
            <Typography type="body2">
              Berikut penjelasan cara bermainnya :
            </Typography>
            <Typography type="body2">
              Setiap ronde terdiri dari 4 fase : fase join, fase angkat jempol,
              fase menjawab and fase akhir permainan.
            </Typography>
            <Typography type="body2">1. fase join</Typography>
            <Typography type="body2">
              Ketik /startgame atau /chaosgame untuk memulai, lalu tekan tombol
              Join untuk ikut permainan. Fase ini berlangsung selama 60 detik.
            </Typography>
            <Typography type="body2">2. fase angkat jempol</Typography>
            <Typography type="body2">
              Setiap pemain yang ikut bermain dapat memilih satu {`\u{1F44D}`},
              dua {`\u{1F44D}`} atau bahkan tidak mengangkat jempol ({`\u{1F6AB}`}).
              Bot akan menghitung jumlah {`\u{1F44D}`} dan bot akan menunjuk
              seorang pemain untuk menebak jumlah {`\u{1F44D}`} yang diangkat.
              Fase ini akan berlangsung maksimal 60 detik.
            </Typography>
            <Typography type="body2">3. fase menjawab</Typography>
            <Typography type="body2">
              Bot akan menyebutkan nama pemain yang harus menjawab jumlah{' '}
              {`\u{1F44D}`}. Untuk menjawab, pemain hanya perlu menuliskan angka
              nya saja. Jika jawaban pemain benar, maka pemain tersebut akan
              mendapatkan nilai tambahan.
            </Typography>
            <Typography type="body2">
              Untuk permainan Normal, 1 point untuk setiap jawaban benar
            </Typography>
            <Typography type="body2">
              Untuk permainan Chaos, pemain akan mendapatkan tambahan point
              sejumlah {`\u{1F44D}`}.
            </Typography>
            <Typography type="body2">4. fase akhir permainan</Typography>
            <Typography type="body2">
              Permainan akan berakhir ketika salah satu pemain mendapatkan point
              tertentu.
            </Typography>
            <Typography type="body2">
              Untuk permainan Normal, pemain harus mendapatkan 3 Point untuk
              menjadi pemenang.
            </Typography>
            <Typography type="body2">
              Untuk permainan Chaos, jumlah point menang bergantung jumlah
              pemain dengan minimal 10 point
            </Typography>
          </div>
        </Paper>
      </div>
    );
  };

  /**
   * Rendering Intro includes : Main Logo, Features
   */
  renderIntro = () => {
    return (
      <div style={{padding: '1rem'}}>
        <Grid container>
          <Grid item xs={12}>
            <div style={{padding: '1rem', textAlign: 'center'}}>
              <img
                src="AduJempol.png"
                alt="main logo"
                style={{maxWidth: '300px', width: '100%'}}
              />
              <Typography type="display1" style={{color: 'white'}}>
                Permainan tebak jempol di LINE Messenger
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Paper style={{padding: '2rem', textAlign: 'center'}}>
              <Grid container>
                <Grid item xs={12} md={4}>
                  <div>
                    <svg
                      enableBackground="new 0 0 50 50"
                      height="50px"
                      id="Layer_1"
                      version="1.1"
                      viewBox="0 0 50 50"
                      width="50px"
                    >
                      <path
                        d="M18,39v4c0,1.1,0.9,2,2,2h10  c1.1,0,2-0.9,2-2v-4H18z"
                        fill="none"
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                      />
                      <rect fill="none" height="50" width="50" />
                      <path
                        d="M32,39c0-1,0-4.021,0-6  c0-5.385,7-5.568,7-15c0-7.733-6.268-14-14-14s-14,6.267-14,14c0,9.633,7,10.692,7,15c0,1.305,0,6,0,6"
                        fill="none"
                        stroke="#000000"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                      />
                      <path
                        d="M28,45c0,1.656-1.344,3-3,3  s-3-1.344-3-3"
                        fill="none"
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                      />
                      <line
                        fill="none"
                        stroke="#000000"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                        x1="25"
                        x2="25"
                        y1="23"
                        y2="36"
                      />
                      <polyline
                        fill="none"
                        points="21,19 25,23 29,19   "
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                      />
                    </svg>
                    <Typography type="headline">Sederhana</Typography>
                    <Typography type="subheading">
                      Aturan main yang sederhana, dan mudah dimengerti
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <svg
                    enableBackground="new 0 0 50 50"
                    height="50px"
                    id="Layer_1"
                    version="1.1"
                    viewBox="0 0 50 50"
                    width="50px"
                  >
                    <rect fill="none" height="50" width="50" />
                    <path
                      d="M24.933,33.528  c-0.146-1.612-0.09-2.737-0.09-4.21c0.73-0.383,2.038-2.825,2.259-4.888c0.574-0.047,1.479-0.607,1.744-2.818  c0.143-1.187-0.425-1.855-0.771-2.065c0.934-2.809,2.874-11.499-3.588-12.397c-0.665-1.168-2.368-1.759-4.581-1.759  c-8.854,0.163-9.922,6.686-7.981,14.156c-0.345,0.21-0.913,0.878-0.771,2.065c0.266,2.211,1.17,2.771,1.744,2.818  c0.22,2.062,1.58,4.505,2.312,4.888c0,1.473,0.055,2.598-0.091,4.21C13.367,38.238,1.546,36.916,1,46h38  C38.455,36.916,26.685,38.238,24.933,33.528z"
                      fill="none"
                      stroke="#000000"
                      strokeLinecap="round"
                      strokeMiterlimit="10"
                      strokeWidth="2"
                    />
                    <path
                      d="M36.422,40.587H49  c-0.457-7.649-10.37-6.534-11.847-10.5c-0.122-1.359-0.075-2.306-0.075-3.547c0.616-0.323,1.717-2.378,1.903-4.115  c0.481-0.041,1.245-0.511,1.47-2.373c0.119-1-0.36-1.562-0.652-1.74c0.786-2.367,2.422-9.683-3.021-10.44  c-0.56-0.983-1.993-1.48-3.858-1.48c-2.353,0.043-4.052,0.62-5.227,1.587"
                      fill="none"
                      stroke="#000000"
                      strokeLinecap="round"
                      strokeMiterlimit="10"
                      strokeWidth="2"
                    />
                  </svg>
                  <Typography type="headline">Group Play</Typography>
                  <Typography type="subheading">
                    Dapat dimainkan bersama teman dalam room ataupun group
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <svg
                    enableBackground="new 0 0 50 50"
                    height="50px"
                    id="Layer_1"
                    version="1.1"
                    viewBox="0 0 50 50"
                    width="50px"
                  >
                    <rect fill="none" height="50" width="50" />
                    <circle cx="2" cy="25" r="2" />
                    <circle cx="15" cy="19" r="2" />
                    <circle cx="25" cy="11" r="2" />
                    <circle cx="35" cy="17" r="2" />
                    <circle cx="48" cy="5" r="2" />
                    <circle cx="2" cy="39" r="2" />
                    <circle cx="15" cy="41" r="2" />
                    <circle cx="25" cy="33" r="2" />
                    <circle cx="35" cy="43" r="2" />
                    <circle cx="48" cy="31" r="2" />
                    <polyline
                      fill="none"
                      points="2,25 15,19 25,11   35,17 48,5 "
                      stroke="#000000"
                      strokeLinecap="round"
                      strokeMiterlimit="10"
                      strokeWidth="2"
                    />
                    <polyline
                      fill="none"
                      points="2,39 15,41 25,33   35,43 48,31 "
                      stroke="#000000"
                      strokeLinecap="round"
                      strokeMiterlimit="10"
                      strokeWidth="2"
                    />
                  </svg>
                  <Typography type="headline">
                    Game Summary & Statistic
                  </Typography>
                  <Typography type="subheading">
                    Game Summary yang menarik dan lengkap
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  };

  renderHowTo = () => {
    return (
      <div style={{padding: '1rem'}}>
        <Paper>
          <div style={{padding: '2rem'}}>
            <div style={{marginBottom: '2rem'}}>
              <Typography type="headline" gutterBottom>
                Cara Bermain
              </Typography>
            </div>
            <div style={{marginBottom: '1rem'}}>
              <Typography type="title">Tambahkan sebagai teman</Typography>
              <Typography type="body1" gutterBottom>
                Tambahkan Adu Jempol Official Account sebagai teman untuk
                memudahkan kamu meng-invite bot ke group mu. Selain itu bot juga
                perlu mengenalimu untuk membuat game summary.
              </Typography>
            </div>
            <div style={{marginBottom: '1rem'}}>
              <Typography type="title">Invite bot ke Group</Typography>
              <Typography type="body1" gutterBottom>
                Adu Jempol dimainkan bersama teman dalam group, jadi jangan lupa
                untuk meng-invite bot mu ke group ya
              </Typography>
            </div>
            <div style={{marginBottom: '1rem'}}>
              <Typography type="title">Mulai Bermain</Typography>
              <Typography type="body1" gutterBottom>
                Ketik /play untuk memulai, lalu pilih mode game nya. Ajak temanmu
                untuk ikut bermain dengan cara menekan tombol Join dari bot
              </Typography>
              <Typography type="body1">
                <a href="/tutorial">Selengkapnya...</a>
              </Typography>
            </div>
          </div>
        </Paper>
      </div>
    );
  };
  render() {
    return (
      <HeaderBar
        title="Adu Jempol Home Page"
        button="add"
        bodyStyle={{background: '#0081FA'}}
      >
        <div>
        <Helmet>
          <meta property="og:image" content="AduJempol.png" />
          <meta property="og:url" content={window.location.href} />
          <meta
            property="og:description"
            content="Adu Jempol Homepage"
          />
          <title>Adu Jempol Homepage</title>
        </Helmet>
          {this.renderIntro()}
          {this.renderHowTo()}
          {/* {this.renderGettingStarted()} */}
        </div>
      </HeaderBar>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/Homepage.js